import {condition, request} from "../../../../../res/rest/restRequest";
import {env} from "../../../../../res/config/env";
import axios from "axios";
import {api} from "../../../../../res/rest/api";


const processResult = (result) => {
    return result.data.records;
}

const productPurchaseInfoRequest = (orgID, bPartnerID) => {

    const req = request.model("web_product_purchase_info_v")
        .filter(condition.eq("c_bpartner_ID", bPartnerID))
        .expand(request.subQueryList("web_product_discount_v")
            .filter(condition.eq("isActive", "true"))
            .filter(condition.eq("AD_Org_ID", orgID))
        )
        .expand(request.subQueryList("price_bpartner_break_current_v")
            .filter(condition.eq("c_bpartner_ID", bPartnerID)))
        .expand(request.subQueryList("m_product_uom_v"))
        .hostURL(env.API_URL)

    const requestBuilder = {};

    requestBuilder.productIDs = (productIDs) => {
        req.filter(condition.in("m_product_ID", ...productIDs));
        return requestBuilder;
    }

    requestBuilder.sendRequest = async (session) => {
        const result = await axios.get(req.buildRequest(), api.auth(session));
        return processResult(result);
    }

    return requestBuilder;

}

export default productPurchaseInfoRequest;
